export const ListQueryKey = 'merchants';
export const DetailQueryKey = 'merchant';
export const Urls = {
  selectUrl: '/admin/list',
  updateUrl: '/admin/update',
  deleteUrl: '/admin/delete',
  createUrl: '/admin/create',
  detailUrl: '/admin/detail'
};